module.exports = __webpack_public_path__ + "static/media/imagemColetoresImpressorasZebra.45d56553.png";